import createComputed from 'modules/core/hooks/createComputed'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

const useLegalEntityOptions = createComputed((legalEntities) =>
  legalEntities.map((le: LegalEntity) => {
    return {
      label: le.attributes.legal_name,
      value: le.attributes.id,
    }
  })
)

export default useLegalEntityOptions
